<template>
     <div class="proizvodi">

         <!-- <div class="main">
           <div class="slika1 animated fadeIn slower">


           </div>
         </div> -->

       <div id="kajron" class="kajron">
         <div class="wrapper">
           <router-link to="/proizvodi"><p v-if="this.$route.params.podkategorije" style="float:left"><i class="fas fa-undo"></i></p></router-link>
           <h3>{{naziv}}</h3>
         </div>
       </div>
       <div  class="wrapper">
         <div class="">
           <div class="">
             <!-- meni za pretragu -->

                   <div id="pretraga1" class="pretraga">
                       <ul class="menu">

                          <li v-for="kat in kategorije"
                              @mouseover="list = kat.kat_id"
                              @mouseleave="list = ''" type="" name="" ><span @click="grupa(kat.kat_naziv)">{{kat.kat_naziv}}</span> <i class="fa fa-caret-down"></i>

                            <transition name="fade" >
                                  <ul v-if="list == kat.kat_id">
                                    <li v-for="pod in podkategorije" v-show="pod.kat_id == kat.kat_id" @mouseover="listtwo = pod.pod_id" @click="podgrupa(kat.kat_naziv,pod.pod_naziv),list = '' ">{{pod.pod_naziv}}

                                    </li>
                                  </ul>
                            </transition>
                          <span class="caret"></span>
                        </li>
                     </ul>
                  </div>
                  <!-- <div id="" :class="{filterimob:filter == false , filterin:filter == true}" @click="preventClose($event)">
                      <ul class="menu">

                         <li v-for="kat in kategorije"
                           type="" name="" ><span @click="grupa(kat.kat_naziv)">{{kat.kat_naziv}}</span>
                         <span class="caret"></span>
                       </li>
                    </ul>
                 </div> -->
       <!-- podkategorije -->
                   <div v-if="!this.$route.params.podkategorije" class="linija">
                     <div class="brand" v-for="bra in brand">
                       <img :src="brandurl + bra.bra_id" alt="">
                     </div>
                   </div>
                  <div class="single" v-show="showkat"  v-for="kat in kategorije" :id="kat.kat_naziv" >
                    <div class="naslov">
                      <h3>{{kat.kat_naziv}}</h3>

                    </div>
                    <div class="container" :id="kat.kat_naziv">

                        <div class="card" v-for="pod in podkategorije" v-show="pod.kat_id == kat.kat_id" @click="podgrupa2(kat.kat_naziv,pod.pod_naziv), setopis(true)">
                          <h3 class="title">{{pod.pod_naziv }}</h3>
                          <div class="bar">
                            <div class="emptybar"></div>
                            <div class="filledbar"></div>
                          </div>
                          <div class="circle">
                            <img  :src="podkaturl+pod.pod_id"  alt=""  >
                            <!-- <img :src="podkaturl+pod.pod_id"  alt=""  > -->
                          </div>
                        </div>


                    </div>
                 </div>

                 <podkategorije  v-show="!showkat"></podkategorije>


           </div>
         </div>

       </div>

    </div>

</template>

<script>
import podkategorije from '@/components/podkategorije'
import {mapGetters, mapActions, mapMutations} from 'vuex';

export default {
  components: {
  podkategorije
  },
  data () {
    return {
      filter:false,
      list:"",
      listtwo:"",

    }
  },
  computed:{
    ...mapGetters([
        'naziv',
        'showkat',
        'showterms',
        'showopis',
        'kategorije',
        'podkategorije',
        'brand',
        'brandurl',
        'podkaturl',
        'pro',
        'getopis',
        'kurs'

    ]),


  },
  watch:{
    $route:function(to, from){

      if(this.$route.params.kategorije != undefined){
        if(this.$route.params.podkategorije != undefined){
            this.setnaziv( this.$route.params.kategorije +' - '+ this.$route.params.podkategorije)
            this.getpro(this.$route.params.podkategorije)
            this.setkat(false)

        }else {
          this.setnaziv(this.$route.params.kategorije)
          this.getsinglpk(this.$route.params.kategorije)
          this.setkat(true)
        }
  }else{
    this.setnaziv("Pronadji svoj proizvod")
    this.getproizvodi()
    this.setkat(true)
  }


    },


  },
  created(){
    window.scrollTo({top: 0, behavior: 'smooth'});
    this.getproizvodi()

    if(this.$route.params.kategorije != undefined){
      if(this.$route.params.podkategorije != undefined){
        this.setnaziv( this.$route.params.kategorije +' - '+ this.$route.params.podkategorije)
        this.getpro(this.$route.params.podkategorije)
        this.setkat(false)
      }else {
        this.setnaziv(this.$route.params.kategorije)
        this.getsinglpk(this.$route.params.kategorije)
        this.setkat(true)
      }
}else{
  this.setnaziv("Pronadji svoj proizvod")
  this.getproizvodi()
  this.setkat(true)
}

  },
  methods:{
    podgrupa2(kategorija,podkategorija){
      this.$router.push("/proizvodi/"+kategorija +'/' + podkategorija)
    },
    grupa(kategorija){
        document.getElementById('kategorija').scrollIntoView(false)
        this.$router.push("/proizvodi/"+kategorija)
    },
    podgrupa(kategorija,podkategorija){
        this.$router.push("/proizvodi/"+kategorija +'/' + podkategorija)
    },

    // term(e){
    //   this.setterms(!this.showterms);
    //     e.stopPropagation()
    // },
    ...mapMutations([
      'setterms',
      'setkat',
      'setnaziv',
      'singlpk',
      'setopis',

  ]),
  ...mapActions([
      'getproizvodi',
      'getsinglpk',
      'getbrand',
      'getpro',
      'getkurs'


  ]),
    term(e){
      this.setterms(!this.showterms);
        e.stopPropagation()
    },


    discover(kategorija){

      this.$router.push("/proizvodi/"+kategorija)

    },



  },
  mounted(){
    window.scrollTo({top: 0, behavior: 'smooth'});
    this.getkurs()
    this.getproizvodi()
    this.getbrand()
    if (this.$route.params.kategorije && !this.$route.params.podkategorije) {
      var kateg = document.getElementById(this.$route.params.kategorije);
        document.getElementById(this.$route.params.kategorije).scrollIntoView(false)
    }

    // window.scroll(0,0);
    // this.checksession(this.getsid)

  }
}
</script>

<style scoped>
#search {
  max-width: 400px;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/proizvodi.vue